import { render, staticRenderFns } from "./GES1point5Results.vue?vue&type=template&id=d221a3f2&scoped=true"
import script from "./GES1point5Results.vue?vue&type=script&lang=js"
export * from "./GES1point5Results.vue?vue&type=script&lang=js"
import style0 from "./GES1point5Results.vue?vue&type=style&index=0&id=d221a3f2&prod&lang=css"
import style1 from "./GES1point5Results.vue?vue&type=style&index=1&id=d221a3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d221a3f2",
  null
  
)

export default component.exports